import { ConfigurationSecurityRight } from '../../security/modules/configuration.security.module';

/**
 * Internal app-level permissions used by the harness command path.
 *
 * In v1 these map to existing tenancy-management rights rather than a new
 * dedicated security module, which keeps stage 0 compile-time only.
 */
export const AgentHarnessPermission = {
    ViewAgents: 'view_agents',
    ManageAgents: 'manage_agents',
} as const;

export type AgentHarnessPermission = typeof AgentHarnessPermission[keyof typeof AgentHarnessPermission];

export const AGENT_HARNESS_V1_PERMISSION_RIGHTS: Readonly<Record<AgentHarnessPermission, readonly ConfigurationSecurityRight[]>> = Object.freeze({
    [AgentHarnessPermission.ViewAgents]: [ConfigurationSecurityRight.AccessTenancy],
    [AgentHarnessPermission.ManageAgents]: [ConfigurationSecurityRight.ManageTenancy],
});
